var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecordingSidebarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "recording",
    transform: "translate(65.114 739.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6184",
    "data-name": "Path 6184",
    d: "M-57.614-735.8a4,4,0,0,0-4,4,4,4,0,0,0,4,4,4,4,0,0,0,4-4A4,4,0,0,0-57.614-735.8Zm1.672,4.727a.941.941,0,0,1-.941.941h-1.456a.94.94,0,0,1-.94-.941v-1.456a.94.94,0,0,1,.94-.94h1.456a.94.94,0,0,1,.941.94Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6185",
    "data-name": "Path 6185",
    d: "M-53.109-739.3h-9.01a3,3,0,0,0-2.995,2.995v9.01a2.994,2.994,0,0,0,2.995,2.995h9.01a2.994,2.994,0,0,0,3-2.995v-9.01A3,3,0,0,0-53.109-739.3Zm-4.5,12.5a5,5,0,0,1-5-5,5,5,0,0,1,5-5,5,5,0,0,1,5,5A5,5,0,0,1-57.614-726.8Z",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordingSidebarIcon);
export default __webpack_public_path__ + "static/media/recording-sidebar-icon.13996909a36b010744e23a9166913dc5.svg";
export { ForwardRef as ReactComponent };